<template>  
<div @mouseover="setHover(true)"  ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">         
    <v-progress-circular v-if="loadingData" :width="15" :size="350" :value="loadingValue" color="primary"  style="align-self:center;margin-bottom:auto;margin-top:auto">
      <span class="headline">{{$t('Pilot.Graphics.LoadingData')}}</span>
    </v-progress-circular>                
    <div v-else-if="!loadedData">                
      <v-alert  :value="true" type="info"  >{{$t('Pilot.Graphics.FailDownloadData')}}</v-alert>
      <v-btn color="primary" @click="tryEnsureData()">{{$t('Pilot.Graphics.TryReload')}}</v-btn>
    </div>    
    <template v-else-if="mission.dataScience.length > 0">
      <v-layout row justify-center style="flex:0 0 auto;">
        <v-btn small :color="dataLimitMode === dataLimit?'secondary':'primary'" v-for="dataLimitMode in $options.dataLimitModes" :key="dataLimitMode"              
             @click="$store.myActions.UI_SET_GRA_DATA({uiid,name:'dataLimit',value:dataLimitMode})" >{{$t(`Pilot.Graphics.LimitData${dataLimitMode}`)}}</v-btn>
        <v-btn small icon @click="refreshScienceGraphCache()" ><v-icon>mdi-refresh</v-icon></v-btn>
      </v-layout>      
      <div style="flex:1 0 auto;position:relative;" class="mr-4">
        <div class="scrollable-container" style="padding-right: 0px;left: 0px;">
   <Responsive :breakpoints="{
    small: el => el.width <= 420
  }">        
  <v-layout  slot-scope="el" @mousedown.prevent.stop="stopClick" ref="detail" mt-2 row wrap>  
    <template v-for="(graphGroup,index) in sciGraphs"> 
    <v-flex class="inline-block xs12 text-xs-center body-2 mt-1 !grow-0" :key="graphGroup.name">{{tryTranslate(graphGroup.name)}}</v-flex>
    <v-flex style="position:relative;" class="px-2" :class="{sm12:el.is.small,sm8:!el.is.small && graph.size==4,sm4:!el.is.small && graph.size==2}" v-for="graph in graphGroup.graphs" :key="graph.id">            
      <v-btn icon @click="selectGraph(graph)" small style="position:absolute;top:3px;left:3px;z-index:1"><v-icon>mdi-magnify-plus</v-icon></v-btn>
        <div class="graph mb-2" >          
          <mission-scatter-plot      
              :sciGraph="true" 
              :mainVariable="graphGroup.name"
              :pointSize="1" 
              :abscisseVariable="graph.abscisse"
              :ordonneeVariable="graph.ordonnee"
              :colorVariable="graph.color"
              :uiid="uiid" 
              :prefixe="graph.id"
              :allowClick="true"
              :allowZoom="false"                        
              :marginWidth="5"   
              :offsetLegendX="5"
              :offsetLegendY="5"  
              :colorGradientWidth="5"            
              :offsetLegendColor="5"
              :xTicks="graph.xTicks"
              :yTicks="5"
              :colorTicks="5"      
              :useCacheImg="true"
              :redraw="componentRefresh"              
              :dataLimit="dataLimit"
              :autoScaleX="graph.autoScaleX" 
              :mission="mission"
              :tabState="tabState"             
              />        
        </div>
      </v-flex>  
      <v-flex v-if="index != sciGraphs.length-1"  class="xs12" :key="`hr_${graphGroup.name}`"> <hr  />        </v-flex>
    </template>     
  </v-layout>     
    </Responsive></div> 
    </div>    
    <mission-graph-hover-data
        :uiid="uiid" 
        :sciGraph="true"
        prefixe="hoverdata_sci"         
        :dataLimit="dataLimit"
        :mission="mission"
        :tabState="tabState"
     /> 
    </template>
    <template v-else>
      <span class="display-2" style="margin:auto">{{$t('Pilot.Graphics.NoDataAvailable')}}</span>
    </template>        
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'  
  import {zoomIdentity} from 'd3'  
  import MissionScatterPlot from '@/components/charts/MissionScatterPlot'
  import MissionGraphHoverData from '@/components/mission/MissionGraphHoverData.vue'
  import { dataLimitMode } from '@/models/ui/GraphUiState'
  import { AloMission } from '@/models/alo/AloMission'

  export default {
    components:{MissionScatterPlot,MissionGraphHoverData},
    props:  {
      isleft:Boolean,
      uiid:{
          type: String,
          required: true
      },
      mission:{
        type:AloMission,
        required:true
      },
      tabState:{
        required:true
      }
   },      
   name: 'MissionDetailScienceGraphicsListGen',   
   data(){
     return {
        interval: {},
        loadingValue: 0
      }
   },
   mounted() {     
     if(this.loadingData){
      this.interval = setInterval(() => {
        this.loadingValue = (this.loadingValue + 10) % 110        
      }, 1000)
     }
   },
   computed: {
       ...mapGetters([                     
         'uistatebyuiid'
      ]),           
      loadingData(){        
        //console.log(this.mission,this.missions[this.missions.findIndex(m => m.misId == this.mission.misId)])
        return !!this.mission._dataScienceLoading
      },  
      loadedData(){        
        //console.log(this.mission,this.missions[this.missions.findIndex(m => m.misId == this.mission.misId)])
        return !!this.mission._dataScienceLoaded
      },     
      allGraphUiState() {                
        return this.uistatebyuiid(this.uiid)
      },           
      dataLimit(){
        return this.allGraphUiState.dataLimit
      },
      leftPanelWidth(){
        return this.tabState.leftPanelWidth
      },
      componentRefresh() {
        return this.allGraphUiState && this.allGraphUiState.refresh
      },          
      sciGraphs() {
        return this.mission.sciPlotVariables.filter(g => g.autoPlot
          && (g.name.toLowerCase().indexOf('ad2cp_v') == -1 || g.name.toLowerCase().indexOf('_cn2') > 0)
        ).map(sciPlotVariable => {
            return { 
              name: sciPlotVariable.name,                     
              graphs: [{
                id: `COLOR_${sciPlotVariable.variable}`,
                name : "Color " + sciPlotVariable.name,
                abscisse : this.mission.xSciScatterVariable,
                ordonnee : this.mission.ySciScatterVariable,
                color : sciPlotVariable.variable,
                transform : zoomIdentity,
                size : 4,
                xTicks: 3,
                dataLimit: this.dataLimit,
                autoScaleX:false
              },{
                id: `PROFILE_${sciPlotVariable.variable}`,              
                name : "Profile " + sciPlotVariable.name,
                abscisse : sciPlotVariable.variable,
                ordonnee : this.mission.ySciProfileVariable,
                color : "None",
                transform : zoomIdentity,
                size : 2,
                xTicks: 5,
                dataLimit: this.dataLimit,
                autoScaleX: true
              }]
            }
        }) 
      }
    },    
    created() {
      this.$store.myActions.UI_ENSURE_ALL_GRA_STATE(this.uiid)
      this.tryEnsureData()      
      this.$options.dataLimitModes = [dataLimitMode.LAST_12H,dataLimitMode.LAST_24H,dataLimitMode.ALL]
    },
    watch : {
      uiid(newValue) {
        this.$store.myActions.UI_ENSURE_ALL_GRA_STATE(newValue)
      },
      mission(newValue) {
       this.tryEnsureData()
      },
      leftPanelWidth(newValue) {
        this.allGraphUiState.refresh = !this.allGraphUiState.refresh
      },
      loadingData(newValue) {
        if(!newValue) {
          clearInterval(this.interval)
        }
        else{
          this.interval = setInterval(() => {
            this.loadingValue = (this.loadingValue + 10) % 110        
          }, 1000)
        }
      }
    },    
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {    
       tryEnsureData(){          
          if(this.mission.misId != null) {   
            if(this.mission.covId){              
              this.$store.myActions.COVERAGEITERATION_ENSURE_DATA_SCIENCE({covId:this.mission.covId,gliderKey:`GLIDER${this.mission.misIdx+1}`})
            }     
            else if(this.mission.isVirtual){              
              this.$store.myActions.MISSIONVIRTUAL_ENSURE_DATA_SCIENCE(this.mission.misId)
            }
            else{
              this.$store.myActions.MISSION_ENSURE_DATA_SCIENCE(this.mission.misId)
            }                              
          }
      },
      tryTranslate(key) {        
        const transKey = `Pilot.Graphics.${key}`
        const trad = this.$t(transKey)
        return transKey == trad?key:trad
      },
      selectGraph(graph){                   
        this.$emit("selectGraph",graph)                    
      },
      refreshScienceGraphCache(){
        this.$store.myActions.UI_REFRESH_SCI_GRAPH_CACHE({id:this.mission.misId,importedCsvHeaders:null})
      },
      stopClick(){

      },
      setHover(visible)
      {        
        this.$store.myActions.UI_SET_GRAPH_HOVER_DATA_VISIBILITY(visible)       
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .graph{
    border:1px solid #ddd;
    box-sizing: content-box;
    width:100%;
    height:175px;
    position:relative;
    cursor: pointer;
  }
</style>
